/**
 * @generated SignedSource<<762221e72746c83775d0499ca4a7372f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubIssueTypeIndicator$data = {
  readonly issueType: {
    readonly id: string;
    readonly isEnabled: boolean;
    readonly name: string;
  } | null | undefined;
  readonly number: number;
  readonly viewerCanSeeIssueType: boolean;
  readonly " $fragmentType": "SubIssueTypeIndicator";
};
export type SubIssueTypeIndicator$key = {
  readonly " $data"?: SubIssueTypeIndicator$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubIssueTypeIndicator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubIssueTypeIndicator",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanSeeIssueType",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "ba8679bd060aed4e846e439be2b1db0f";

export default node;
